import { useRouter } from "next/router";
import { PATHS } from "~/const/paths";
import { G_VideoRatingCategory, G_ViewableRating } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";

const PG12_OR_HIGHER_RATINGS = [
  G_VideoRatingCategory.R18Adult,
  G_VideoRatingCategory.R18Gravure,
  G_VideoRatingCategory.R18,
  G_VideoRatingCategory.R15,
  G_VideoRatingCategory.Pg12,
];

const R15_OR_HIGHER_RATINGS = [
  G_VideoRatingCategory.R18Adult,
  G_VideoRatingCategory.R18Gravure,
  G_VideoRatingCategory.R18,
  G_VideoRatingCategory.R15,
];

const R18_OR_HIGHER_RATINGS = [
  G_VideoRatingCategory.R18Adult,
  G_VideoRatingCategory.R18Gravure,
  G_VideoRatingCategory.R18,
];

const RESTRICT_RATINGS = [G_VideoRatingCategory.R18Adult, G_VideoRatingCategory.R18Gravure];

export const useRatingBlock = () => {
  const { viewableRating, isLoggedIn } = useAuth();
  const { asPath } = useRouter();

  const isRestrictedIfLoggedIn = (videoRatingCategory: G_VideoRatingCategory, viewableRating?: G_ViewableRating) => {
    switch (viewableRating) {
      case G_ViewableRating.G: {
        return PG12_OR_HIGHER_RATINGS.includes(videoRatingCategory);
      }
      case G_ViewableRating.Pg12: {
        return R15_OR_HIGHER_RATINGS.includes(videoRatingCategory);
      }
      case G_ViewableRating.R15: {
        return R18_OR_HIGHER_RATINGS.includes(videoRatingCategory);
      }
      case G_ViewableRating.R18Restrict: {
        return RESTRICT_RATINGS.includes(videoRatingCategory);
      }
      default: {
        return false;
      }
    }
  };
  /**
   * ユーザーの視聴制限と作品のレーティング情報を見て、制限された作品かどうかを判定する
   * 制限されていた場合は:true 制限されていない場合は:false
   * 例外として、作品詳細 or ミニ末端  または /vod/restrict/"以外からはじまるURLの場合は未ログイン状態でも、G_ViewableRating.Gがかかっていることと同じ状態とする
   */
  const isRestrictedContentByUserStatus = (videoRatingCategory: G_VideoRatingCategory, isContentsDetail = false) => {
    const isRestrictedPage = asPath.startsWith(PATHS.VOD_GRAVURE);

    if (isLoggedIn) {
      return isRestrictedIfLoggedIn(videoRatingCategory, viewableRating);
    }
    // 作品詳細 or ミニ末端  または "/vod/restrict/"以外からはじまるURLの場合は未ログイン状態でも、G_ViewableRating.Gがかかっていることと同じ状態とする
    if (isContentsDetail || !isRestrictedPage) {
      return R18_OR_HIGHER_RATINGS.includes(videoRatingCategory);
    }

    return false;
  };

  const disallowAutoPlaySampleMovie = (videoRatingCategory: G_VideoRatingCategory) => {
    const isRestrictedPage = asPath.startsWith(PATHS.VOD_GRAVURE);
    if (isLoggedIn) {
      return isRestrictedIfLoggedIn(videoRatingCategory, viewableRating);
    }
    if (isRestrictedPage) {
      return false;
    }
    return R15_OR_HIGHER_RATINGS.includes(videoRatingCategory);
  };

  return { isRestrictedContentByUserStatus, disallowAutoPlaySampleMovie };
};
